import PropTypes from 'prop-types';
import React from 'react';
import styles from './RefinementButton.scss';
import Icon from '../../../../shared/components/Icon';

const RefinementButton = ({ xVisibleText, mVisibleText, className, onRef, iconName = 'filter' }) => (
  <span ref={onRef} className={[styles.button, className].join(' ')}>
    <Icon name={iconName} className={styles.buttonIcon} />
    <span className={styles.mVisible}>{mVisibleText}</span>
    <span className={styles.xVisible}>{xVisibleText}</span>
  </span>
);

RefinementButton.propTypes = {
  xVisibleText: PropTypes.string,
  mVisibleText: PropTypes.string,
  className: PropTypes.string,
  iconName: PropTypes.string,
  onRef: PropTypes.func,
};

export default RefinementButton;
